import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'reflexbox';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from "@mui/material/Avatar";
import emojiOptions from "../../helpers/emojiOptions"

const TeamMemberNamesList = (props) => {

  return (
    <>
      {Object.entries(props.teammateInfo).map(([teammatesUid, memberInfo]) => (
        <Flex key={teammatesUid} style={{ alignItems: 'center', paddingTop: '8px' }}>
          <Avatar style={memberInfo.color && {backgroundColor: memberInfo.color}}>{
            memberInfo.character >= 0 && emojiOptions[memberInfo.character] ? emojiOptions[memberInfo.character] : memberInfo.name[0]}
          </Avatar>
          <Flex style={{ paddingLeft: '8px', alignItems: 'center' }}>
            <Typography>{memberInfo.name}</Typography>
            {teammatesUid === props.uid && (
              <>
                <Typography> &nbsp;(You)</Typography>
                <Button color="primary" onClick={props.editName}>
                  Edit
                </Button>
              </>
            )}
          </Flex>
        </Flex>
      ))}
    </>
  );
};

TeamMemberNamesList.propTypes = {
  teammateInfo: PropTypes.object.isRequired,
  uid: PropTypes.string.isRequired,
  editName: PropTypes.func.isRequired,
};

export default TeamMemberNamesList;
